import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { propFirms } from '../data/strategy';
export function PropFirmBanner() {
  return <section aria-labelledby="prop-firm-title" className="border-b border-line" data-id="element-64" data-mp="ch9rgp7zly28">
      <div className="mx-auto grid w-full max-w-[1400px] gap-8 px-5 py-12 sm:px-6 lg:grid-cols-12 lg:items-center lg:gap-10 lg:px-10 lg:py-14" data-id="element-65" data-mp="3txhychu53etn">
        <div className="lg:col-span-5" data-id="element-66" data-mp="2pneanc39owu">
          <div className="flex items-center gap-2" data-id="element-67" data-mp="3kwjsrv41yz8y">
            <ShieldCheckIcon className="h-4 w-4 shrink-0 text-gold-vip" aria-hidden="true" data-id="element-68" data-mp="3kzz8n05jwcbf" />
            <span id="prop-firm-title" className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold-vip sm:text-[11px] sm:tracking-[0.22em]" data-id="element-69" data-mp="3azyq3gfia08a">
              Prop Firm Ready
            </span>
          </div>
          <p className="mt-4 max-w-lg text-[14px] leading-relaxed text-white/60 sm:text-[15px]" data-id="element-70" data-mp="195zbom7372rd">
            Estrategia optimizada para superar evaluaciones de fondeo gracias al
            control estricto de Drawdown.
          </p>
        </div>

        <ul className="grid grid-cols-3 gap-px bg-line lg:col-span-7" data-id="element-71" data-mp="15neagclfa9t7">
          {propFirms.map(firm => <li key={firm.name} className="bg-ink px-2 py-4 text-center sm:px-6 sm:py-5" data-id="element-72" data-mp="1jcy9p8fsooxr">
              <span className="block text-[14px] font-semibold tracking-tight text-white/85 sm:text-[17px]" data-id="element-73" data-mp="1fd7jp6y3ecua">
                {firm.name}
              </span>
              <span className="mt-1 block font-mono text-[10px] leading-tight tracking-tight text-white/35 sm:text-[11px]" data-id="element-74" data-mp="moifgz1qpreb">
                {firm.note}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}